import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import EditableButton from '@v4/components/common/EditableButton'
import { useSubmitButton } from './SubmitButton.hooks'

const SubmitButton = props => {
	const [{ classes, loading, className, children, editable }, { handleClick, handleChange }] = useSubmitButton(props)

	return (
		<EditableButton
			loading={loading}
			className={clsx(classes.root, 'q-button', className)}
			disabled={loading}
			onClick={handleClick}
			tabIndex={0}
			editable={editable}
			onChange={handleChange}
		>
			{children}
		</EditableButton>
	)
}

SubmitButton.propTypes = {
	className: PropTypes.string,
	children: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	loading: PropTypes.bool,
	editable: PropTypes.bool,
}

SubmitButton.defaultProps = {
	children: null,
	onClick: () => {},
	editable: false,
	onChange: () => {},
}

export default memo(SubmitButton)
